import React, { useEffect, useState } from "react";

export default function Countdown({ endDate, className = "" }) {
  const [left, setLeft] = useState(null);
  useEffect(() => {
    if (!endDate) return;
    const target = new Date(endDate).getTime();
    const tick = () => {
      const diff = target - Date.now();
      if (diff <= 0) { setLeft(null); return; }
      setLeft({
        d: Math.floor(diff / 86400000),
        h: Math.floor((diff % 86400000) / 3600000),
        m: Math.floor((diff % 3600000) / 60000),
        s: Math.floor((diff % 60000) / 1000),
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [endDate]);

  if (!left) return null;
  const Box = ({ v, l }) => (
    <div className="flex flex-col items-center">
      <span className="font-display font-black text-2xl sm:text-3xl bg-[#0A0A0B]/70 border border-zinc-700 rounded px-3 py-2 min-w-[52px] text-center tabular-nums">{String(v).padStart(2, "0")}</span>
      <span className="text-[9px] font-mono uppercase tracking-widest text-zinc-500 mt-1">{l}</span>
    </div>
  );
  return (
    <div className={`flex gap-2 sm:gap-3 ${className}`} data-testid="drop-countdown">
      <Box v={left.d} l="Ημέρες" /><Box v={left.h} l="Ώρες" /><Box v={left.m} l="Λεπτά" /><Box v={left.s} l="Δευτ." />
    </div>
  );
}
